import { Observable } from 'rxjs';

export class DropdownConfig {
  constructor(
    // if possible, set options equal to a static array (have the data loaded already)
    // if you need the options loaded depending on the specific row data, then use the function option
    //| ((rowData: any, row: any) => Observable<any[]> | any[])
    public options: any[],
    public displayBind: string,
    public valueBind: string
  ) {}
}

export class UpdateInfo {
  constructor(
    public columnDefinition: any,
    public existingValue: any,
    public newValue: any
  ) {}
}

// export class FormInputConfig {
//     constructor(
//         public required = true,
//         public onValueUpdate?: (rowData?: any, row?: any, updateInfo?: UpdateInfo) => Observable<any> | void
//     ) {}
// }
